module.exports = __webpack_public_path__ + "media/images/portugal_center/Abrantes-214e4a9d0663fc778f0c226329c90cd7.jpg";